import { Collapse, CollapseProps, Flex, Image, List } from "antd";
import { t } from "i18next";
import { orderType } from "../../../../types/order";
import Paragraph from "antd/es/typography/Paragraph";
import { formatNumber } from "../../../../utils/formatNumber";
import React, { useState } from "react";
import expandIcon from "../../../../assets/icons/expand-icon.svg";

type OrderAccordionProps = {
  order: orderType;
};

const ExpandIconComponent = () => <Image src={expandIcon} preview={false} />;

const OrderAccordion: React.FC<OrderAccordionProps> = (
  props: OrderAccordionProps,
) => {
  const { order } = props;
  const orderItemLength = order.order_items?.length;
  const [collapseOpen, setCollapseOpen] = useState(orderItemLength === 1);
  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: (
        <Paragraph className="h3-bold text-o-body">
          {t("order items")}
        </Paragraph>
      ),
      children: (
        <List>
          {order.order_items.map((item, index) => (
            <List.Item
              key={index}
              actions={[
                <Paragraph className="note-large text-primary" style={{ color: 'var(--app-foreground-color)' }}>
                  {order?.currency === 'JPY' ? t("{{ currency }}", { currency: order?.currency}) : order?.currency}
                  {order?.currency === 'JPY' ? "" : " "}
                  {order?.currency === 'JPY' ? t("{{ amount }}", {amount: formatNumber(item.price)}) : formatNumber(item.price)}
                </Paragraph>,
              ]}
            >
              <Paragraph className="body-medium text-o-body text-ellipsis">
                {item.name}
              </Paragraph>
            </List.Item>
          ))}
        </List>
      ),
    },
  ];
  if (orderItemLength === 0) {
    return null;
  }
  return (
    <Flex vertical className="top-padding">
      <Collapse
        className="bg-white"
        bordered={false}
        activeKey={collapseOpen ? ["1"] : []}
        onChange={() => orderItemLength > 1 && setCollapseOpen(!collapseOpen)}
        expandIconPosition="end"
        expandIcon={({ isActive }) =>
          orderItemLength > 1 ? (
            <Flex gap={"4px"}>
              <Paragraph className="note-regular text-o-description">
                {t("see more")}
              </Paragraph>
              <Flex
                style={{
                  transform: `rotate(${isActive ? 180 : 0}deg)`,
                  transition: "transform 0.3s",
                }}
              >
                <ExpandIconComponent />
              </Flex>
            </Flex>
          ) : null
        }
        items={items}
      />
      {orderItemLength > 1 && !collapseOpen && (
        <List>
          <List.Item
            actions={[
              <Paragraph className="note-large text-primary" style={{ color: 'var(--app-foreground-color)' }}>
                  {order?.currency === 'JPY' ? t("{{ currency }}", { currency: order?.currency}) : order?.currency}
                  {order?.currency === 'JPY' ? "" : " "}
                  {order?.currency === 'JPY' ? t("{{ amount }}", {amount: formatNumber(order.order_items?.[0].price)}) : formatNumber(order.order_items?.[0].price)}
              </Paragraph>,
            ]}
          >
            <Paragraph className="body-medium text-o-body text-ellipsis">
              {order.order_items?.[0].name}
            </Paragraph>
          </List.Item>
        </List>
      )}
    </Flex>
  );
};
export default OrderAccordion;
